import { getSitePageMetadata } from '../Seo/SiteSeo';

const additionalTitles = {
    '/privacy-policy': 'Privacy Policy | PrepBox',
    '/support': 'Contact PrepBox Support | PrepBox',
    '/terms-of-use': 'Terms of Use | PrepBox',
    '/thankyou': 'Thank You | PrepBox',
    '/schedule': 'Tutoring Schedule | PrepBox',
    '/trial': 'Start a Tutoring Trial | PrepBox',
    '/consultation': 'Book a Math Tutoring Consultation | PrepBox',
};

// Route-owned metadata avoids reading the previous page's document.title
// while a lazy page is still loading. Article content stays in a lazy chunk.
export const resolveAnalyticsPageTitle = (pathname) => {
    const path = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
    const staticPage = getSitePageMetadata(path);
    if (staticPage) return staticPage.title;
    if (additionalTitles[path]) return additionalTitles[path];
    if (['/math-tutoring', '/trigonometry-math-tutoring', '/algebra-math-tutoring'].includes(path)) {
        return getSitePageMetadata('/').title;
    }
    if (/^\/blog\/[^/]+$/.test(path)) {
        const slug = path.slice('/blog/'.length);
        return import('../../content/blog').then(({ getPostBySlug }) => {
            const post = getPostBySlug(slug);
            return post
                ? post.meta.seo?.title || `${post.meta.title} | PrepBox Blog`
                : 'Blog Post Not Found | PrepBox';
        });
    }
    if (/^\/lessons\/[^/]+$/.test(path)) return 'Math Textbook Lessons | PrepBox';
    if (/^\/(workbooks|worksheets)\//.test(path)) {
        return path.includes('/lectures/') ? 'Math Video Solutions | PrepBox' : 'Math Workbook Practice | PrepBox';
    }
    return 'Page Not Found | PrepBox';
};
